<template>
    <CModal @mtdclosemodal="mtdClose" :show="boo_modal" :close-on-backdrop="false" :centered="false" :title="title" :size="'xl'" :btn_cancel="true" :btn_ok="true" :booTitile="true">
        <div class="row px-2">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="col-md-12 table-responsive" id="div-tabla-anular">
                    <table id="tb-anular" class="table table-bordered">
                        <caption class="mx-0 px-0"></caption>
                        <thead class="bg-main" style="font-size: 13px">
                            <tr class="text-white text-center align-middle">
                                <th scope="col">&nbsp;</th>
                                <th scope="col">MARCA</th>
                                <th scope="col">COMERCIAL - MOLECULA - PRESENTACION</th>
                                <th scope="col">DOSIS</th>
                                <th scope="col">VIA</th>
                                <th scope="col">CANTIDAD</th>
                                <th scope="col" class="table-th-row">CANT. APLICADA</th>
                                <th scope="col" class="table-th-row">ULT. APLICACIÓN</th>
                            </tr>
                        </thead>
                        <tbody class="border-main" style="font-size: 12px">
                            <tr v-if="cpData.length === 0">
                                <td colspan="8" class="text-center">SIN REGISTROS</td>
                            </tr>
                            <tr v-for="(det, index) in cpData" :key="index" class="text-center align-middle">
                                <td class="align-middle" v-if="!det.recipe_detail.cancellation_date">
                                    <template v-if="det.quantity_remaining !== 0">
                                        <input class="form-check-input" v-model="det.appliedStatus" type="checkbox" value="" id="flexCheckDefault">
                                    </template>
                                    <template v-else>
                                        <i class="fas fa-check text-success"></i>
                                    </template>
                                </td>
                                <td class="align-middle" v-else>
                                    <span class="badge text-bg-primary">ALTA</span>
                                </td>
                                <td>{{ det.product_detail.brand ? det.product_detail.brand.name : 'Sin Marca'}}</td>
                                <td>{{ det.product_detail.commercial}} - {{ det.recipe_detail.molecule}} - {{ det.recipe_detail.presentation}}</td>
                                <td>{{ det.recipe_detail.dosis ? det.recipe_detail.dosis : '-'}}</td>
                                <td>{{ det.recipe_detail.via}}</td>
                                <td>{{ det.quantity_remaining}}</td>
                                <td>
                                    <input type="text" class="form-control form-control-sm text-center" placeholder="Ingrese Cant." v-on:keypress="isNumber($event)"
                                    :disabled="!det.appliedStatus" v-model="det.appliedQuantity" @input="validateQuantity(det)"/>
                                </td>
                                <td>
                                    <template v-if="det.date_application">
                                        {{ det.date_application | formatDateTime}}
                                    </template>
                                    <template v-else>
                                        <span class="badge text-bg-success">Sin Aplicación</span>
                                    </template>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <template #footer>
            <button class="btn btn-success btn-sm fw-semibold" :disabled="!cpButton" @click="applyMed()">
               APLICAR MED.
            </button>
            <button class="btn btn-primary btn-sm fw-semibold" @click="countMedicine()">
               ALTA
            </button>
            &nbsp;
        </template>
        <SweetAlert :swal="swal" ref="SweetAlert" />
    </CModal>
</template>

<script>
import CModal from "@/components/shared/modals/CModal.vue";
import SweetAlert from '@/components/shared/SweetAlert/SweetAlert.vue';
import {mapActions} from "vuex";
import moment from "moment";

export default {
    name: "c-maintenance-modal-documento",
    components: {
        SweetAlert,
        CModal
    },
    data() {
        return {
            swal: null,
            data_detail: {
            },
            tabla: [],
        };
    },
    watch: {
        payload: {
            handler(newVal) {
            },
            immediate: true,
        },
    },
    props: {
        title: String,
        boo_modal: Boolean,
        medical_act_id: Number,
        payload: {
            type: Array,
            default: () => []
        },
        recipe_ids: {
            type: Array,
            default: () => []
        },
        type: Number,
        pageIni: String
    },
    computed: {
        cpButton() {
            return this.cpData.some(det => det.appliedStatus && det.appliedQuantity && det.appliedQuantity > 0);
        },
        cpData() {
        let show = [];
            this.payload.forEach((element) => {
                show.push(element);
            });
            this.tabla = show;
            return show;
        },
    },
    methods: {
        ...mapActions(["get", "post"]),

        mtdClose() {
            this.$emit("closeModal");
        },

        isNumber: function (evt) {
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            if (
                charCode > 31 &&
                (charCode < 48 || charCode > 57)
            ) {
                evt.preventDefault();
            } else {
                return true;
            }
        },

        validateQuantity(det) {
            if (parseInt(det.appliedQuantity) > parseInt(det.quantity_remaining)) {
                det.appliedQuantity = "";
                this.$refs.SweetAlert.showWarning("La Cant. Aplicada debe ser menor o gual que la Cant. Despachada");
            }
        },

        applyMed() {
            this.$refs.SweetAlert.showConfirmSimple2("¿Deseas Aplicar?", "¡No podrás revertir esto!", "warning", "Confirmar")
            .then((result) => {
                if (result.value) {
                    this.mtdApplyMed();
                }
            });
        },

        mtdApplyMed() {
            const newpayload = this.cpData
            .filter(det => det.appliedStatus && det.appliedQuantity !== null && det.appliedQuantity !== "")
            .map(det => ({
                recipe_detail_id: det.recipe_detail.id,
                appliedQuantity: det.appliedQuantity,
                appliedStatus: det.quantity_remaining,
                quantity: det.appliedStatus
            }));

            this.post({
                url: this.$store.getters.get__url + "/Pharmacy/regRecipe/applyMed",
                token: this.$store.getters.get__token,
                params: {
                    medical_act_id: this.medical_act_id,
                    data: newpayload,
                }
            }).then((response) => {
                if (response.statusCode === 200) {
                    if(response.data){
                        this.clearData();
                        this.$emit("updateData", this.type , this.medical_act_id, this.recipe_ids, this.pageIni);
                        this.$refs.SweetAlert.showSuccess(response.message); 
                    }else{
                        this.$refs.SweetAlert.showWarning('El Medicamento aún no ha sido Despachado'); 
                    }
                }
            });
        },

        clearData() {
            this.cpData.forEach(det => {
                det.appliedStatus = false;
                det.appliedQuantity = "";
            });
        },

        countMedicine() {
            this.$refs.SweetAlert.showConfirmSimple2("¿Estás seguro de dar ALTA al Paciente?", "Verifique si ya Aplicó. ¡No podrás revertir esto!", "warning", "Confirmar")
            .then((result) => {
                if (result.value) {
                    this.mtdDestination();
                }
            });
        },

        mtdDestination() {
            const newReturns = this.cpData
            .filter(det => det.quantity_remaining !== 0)
            .map(det => ({
                id: det.recipe_detail.id,
                quantity: det.quantity_remaining
            }));
            this.post({
                url: this.$store.getters.get__url + "/Pharmacy/regRecipe/destination",
                token: this.$store.getters.get__token,
                params:{
                    id: this.medical_act_id,
                    returns: newReturns,
                    destination: "ALTA",
                },
            })
            .then((response) => {
                if(response.data.result == 1){
                    window.open(
                        this.$store.getters.get__url + "/Emergency/viewpdf/" +
                        this.medical_act_id + '/'+ this.type , "_blank"
                    );
                }
                // console.log(this.pageIni);
                this.$emit("mtdBackApli", this.pageIni);
                this.$refs.SweetAlert.showSuccess(response.message);
            })
            .catch((errors) => {
                this.$refs.SweetAlert.showError(errors);
            });
        }
    },
    filters: {
        formatDate(date) {
            return date != null ? moment(date).format("DD/MM/YYYY") : "-";
        },
        formatDateTime(dateTime) {
            return dateTime != null ? moment(dateTime).format("DD/MM/YYYY HH:mm") : "-";
        },
    },

};
</script>